<header class="fixed top-0 left-0 right-0 z-[200] bg-white border-b-[1px] border-[#C8D0D5]">
  <div
    class="flex items-center h-[54px] mx-auto w-full justify-between gap-2 sm:gap-4"
    [class.!gap-0]="isSearchActive() && (isTablet() || isMobile())"
  >
    <!-- ================= LEFT SECTION (NEVER SHRINKS) ================= -->
    <div class="flex items-center gap-2 sm:gap-4 flex-shrink-0 sm:px-6 px-3 h-full sm:border-r-2 border-[#EBEFF2]">
      <div>
        <pa-menu-popover />
      </div>

      <button
        #profileButton
        (click)="toggleProfileMenu($event)"
        class="flex items-center hover:opacity-80 transition-opacity px-1"
      >
        @if (currentUser?.profile_picture) {
          <div class="relative !w-10 !h-10 rounded-full overflow-hidden">
            <p-avatar
              [image]="currentUser?.profile_picture"
              class="!w-10 !h-10 [&>img]:object-cover"
              [class.blur-sm]="isProfilePictureBlocked()"
              shape="circle"
            />
            @if (isProfilePictureBlocked()) {
              <img src="assets/icons/eye-icon-white.png" alt="Under review"
                class="absolute inset-0 m-auto w-4 h-4 pointer-events-none" />
            }
          </div>
        } @else {
          <div class="w-10 h-10 rounded-full bg-[#2E7FBE] flex items-center justify-center text-white text-[16px] font-bold">
            {{ (currentUser?.first_name + ' ' + currentUser?.last_name) | initials }}
          </div>
        }

<p-menu #profileMenu [popup]="true" styleClass="profile-dropdown-menu" appendTo="body">
        <ng-template pTemplate="start">
          <pa-profile [showSwitchAccount]="true" [isMyCollab]="false" [showBorder]="false" [showProfileInfo]="false" (closePanel)="closeMobileProfilePanel()" (getVerifiedRequest)="onGetVerifiedRequest($event)"/>
        </ng-template>
      </p-menu>
      </button>

      <button class="flex flex-col items-center mt-1 text-[#334D6E] hover:bg-gray-50 px-2 xxxs:pl-[18px]"
        (click)="isAddReqPopupVisible = true"
      >
        <div class="bg-[#334D6E] rounded-[2px] mb-[2px] ">
          <img src="assets/icons/quick-create.svg" class="w-5 h-5 " />
        </div>
        <!-- <span class="text-xs font-medium">Add</span> -->
         
      </button>
      @if(!isMobile() && !isDesktop() && !isHomeScreen && !isDetailPage){
         <!-- Bell/Notification Icon -->
        <button
          (click)="mobileActivity.openLatestActivities()"
          class="relative p-1.5 hover:bg-gray-50 rounded-lg transition-colors"
          aria-label="Notifications"
        >
          <img
            src="assets/icons/activity.svg"
            alt="Notifications"
            class="w-6 h-6 object-contain"
          />
          @if (unreadActivity.hasUnread()) {
            <span class="absolute top-1 right-1 w-2.5 h-2.5 rounded-full bg-red-500 border border-white"></span>
          }
        </button>
      }
    </div>

    <!-- ================= CENTER NAV (ONLY THIS SHRINKS) ================= -->
   @if (isDesktop()) {
      <div class="flex-1 sm:min-w-[90px] min-w-[75px] overflow-hidden transition-all duration-300 ease-in-out">
        <nav #navContainer class="flex items-center sm:justify-center justify-end sm:gap-2 overflow-hidden mx-auto max-w-full">
          @for (item of visibleMenuItems; track item.label) {
            <a [routerLink]="item.routerLink" #rla="routerLinkActive" routerLinkActive="active-nav-item !text-[#334D6E] !border-[#5E9AB9]"
              [class.active-nav-item]="isItemActive(item, rla.isActive)"
              [style.border-bottom-color]="isItemActive(item, rla.isActive) ? '#5E9AB9' : null"
              class="flex flex-col items-center px-2 py-1.5 min-w-[75px] max-w-[90px] text-[#7D838A] !border-b-[4px]  flex-shrink-0 hover:text-[#334D6E] rounded-t-lg transition-colors duration-200 text-sm font-medium border-transparent whitespace-nowrap">
              <span class="relative">
                <img
                  [src]="isItemActive(item, rla.isActive) ? item.activeIcon : item.icon"
                  [alt]="item.label"
                  class="w-[28px] h-[28px] object-contain"
                />
                @if (hasUnreadFor(item.label)) {
                  <span class="absolute -top-0.5 -right-0.5 w-3.5 h-3.5 rounded-full bg-[#C62828] border-[2.5px] border-white" aria-hidden="true"></span><span class="sr-only">Unread messages</span>
                }
              </span>
              <span class="text-xs leading-[12px] text-secondaryText font-medium">{{ item.label }}</span>
            </a>
          }

          @if (moreMenuItems.length > 0) {
            <div class="flex flex-col items-center flex-shrink-0 max-[450px]:hidden">
              <p-menu #moreMenu [model]="moreMenuItems" [popup]="true" styleClass="min-w-[200px]" appendTo="body">
                <ng-template pTemplate="item" let-item>
                  <a [routerLink]="item.routerLink" routerLinkActive="bg-[#5E9AB9]/10 text-[#334D6E]" #rla="routerLinkActive"
                    class="flex items-center gap-3 px-4 py-3 text-[#7D838A] hover:bg-gray-50 hover:text-[#334D6E] transition-colors duration-200 cursor-pointer"
                    style="text-decoration: none; display: flex">
                    <span class="relative">
                      <img [src]="isItemActive(item.data, rla.isActive) ? item.data.activeIcon : item.data.icon" [alt]="item.label" class="w-5 h-5 object-contain" />
                      @if (hasUnreadFor(item.label)) {
                        <span class="absolute -top-0.5 -right-0.5 w-3.5 h-3.5 rounded-full bg-[#C62828] border-[2.5px]  border-white" aria-hidden="true"></span><span class="sr-only">Unread messages</span>
                      }
                    </span>
                    <span class="text-sm font-bold text-[#334D6E]">{{ item.label }}</span>
                  </a>
                </ng-template>
              </p-menu>

              <button (click)="moreMenu.toggle($event)" class="flex flex-col items-center xxs:px-3 py-1.5 text-[#7D838A] hover:text-[#334D6E] min-w-[75px] transition-colors duration-200 !border-b-[4px]"
                [class.active-nav-item]="isMoreMenuActive"
                [class.!border-[#5E9AB9]]="isMoreMenuActive"
                [class.!border-transparent]="!isMoreMenuActive">
                <span class="relative">
                  <img [src]="isMoreMenuActive ? 'assets/icons/more-active.png' : 'assets/icons/more.png'" class="w-[28px] h-[28px]" />
                  @if (hasUnreadInMore()) {
                    <span class="absolute -top-0.5 -right-0.5 w-3.5 h-3.5 rounded-full bg-[#C62828] border-[2.5px]  border-white" aria-hidden="true"></span><span class="sr-only">Unread messages</span>
                  }
                </span>
                <span class="text-xs leading-[12px] text-secondaryText font-medium">More</span>
              </button>
            </div>
          }
        </nav>
      </div>
    }
     <!-- Super Admin indicator -->
        @if (isTablet() && isImpersonating()) {
          <button type="button" (click)="returnToSuperAdmin()"
            class="flex-shrink-0 bg-[#E28C0A] text-white text-base sm:text-[11px] font-semibold  tracking-wide px-3 py-1.5 rounded-[5px]  whitespace-nowrap flex items-center gap-1 hover:opacity-90 transition-opacity">
            <i class="pi pi-arrow-left !text-[14px]"></i>
            Super Admin
          </button>
        } @else if (isTablet() && isSuperAdmin) {
          <span class="flex-shrink-0 bg-[#E28C0A] text-white text-base sm:text-[11px] font-semibold  tracking-wide px-3 py-1.5 rounded-[5px]  whitespace-nowrap pointer-events-none">
            Super Admin View
          </span>
        }

    @if (isMobile() && isSearchActive()) {
      <div class="flex-1 flex items-center px-2">
        <p-iconfield iconPosition="left" class="w-full">
          <p-inputicon (click)="searchQuery ? clearSearch() : null" class="pointer-events-auto cursor-pointer">
            @if (searchQuery) {
              <img src="assets/icons/add.svg" class="rotate-45" alt="Clear" width="16" height="16" />
            } @else {
              <img src="assets/icons/search.svg" alt="Search" width="16" height="16" />
            }
          </p-inputicon>
          <input
            type="text"
            pInputText
            placeholder="Search"
            class="w-full !text-[16px] border-none font-semibold !bg-[#F2F6F8]"
            [value]="searchQuery"
            (input)="onSearchInput($event)"
            (focus)="onSearchFocus()"
          />
        </p-iconfield>
        <button (click)="closeSearch()" class="ml-2 p-1.5 hover:bg-gray-100 rounded-full transition-colors">
          <img src="assets/icons/dismiss.png" class="w-6 h-5" alt="Close" />
        </button>
      </div>
    }

    <!-- ================= RIGHT SECTION (NEVER SHRINKS) ================= -->
    @if (isMobile() && !isSearchActive()) {
      <div class="flex items-center gap-2 flex-shrink-0 px-3 h-full sm:border-l-2 border-[#EBEFF2]">
        <!-- Super Admin indicator -->
        @if (isImpersonating()) {
          <button type="button" (click)="returnToSuperAdmin()"
            class="flex-shrink-0 bg-[#E28C0A] text-white text-[10px] font-semibold uppercase tracking-wide px-2.5 py-1 rounded-full shadow-sm whitespace-nowrap flex items-center gap-1 hover:opacity-90 transition-opacity">
            <i class="pi pi-arrow-left !text-[9px]"></i>
            Super Admin
          </button>
        } @else if (isSuperAdmin) {
          <span class="flex-shrink-0 bg-[#E28C0A] text-white text-[10px] font-semibold uppercase tracking-wide px-2.5 py-1 rounded-full shadow-sm whitespace-nowrap pointer-events-none">
            Super Admin View
          </span>
        }
        @if (isHomeScreen) {
          <button
            type="button"
            (click)="mobileActivity.toggleLeaderboard()"
            class="p-1.5 hover:bg-gray-50 rounded-lg transition-colors"
            aria-label="Leaderboard"
            [attr.aria-pressed]="mobileActivity.showLeaderboard()"
          >
            <img src="assets/icons/leaderboard-trophy.svg" alt="" class="w-5 h-5 object-contain" />
          </button>
        }
        <!-- Bell/Notification Icon -->
        <button
          (click)="mobileActivity.openLatestActivities()"
          class="relative p-1.5 hover:bg-gray-50 rounded-lg transition-colors"
          aria-label="Notifications"
        >
          <img
            src="assets/icons/activity.svg"
            alt="Notifications"
            class="w-[22px] h-[22px] object-contain"
          />
          @if (unreadActivity.hasUnread()) {
            <span class="absolute top-1 right-1 w-2.5 h-2.5 rounded-full bg-red-500 border border-white"></span>
          }
        </button>

        <!-- Search Icon -->
        <button
          (click)="toggleSearch()"
          class="p-1.5 hover:bg-gray-50 rounded-lg transition-colors"
          aria-label="Search"
        >
          <img
            src="assets/icons/search.svg"
            alt="Search"
            class="w-5 h-5 object-contain"
          />
        </button>

        <!-- Access/Key Icon -->
        <button
          (click)="onLogoClick($event)"
          class="p-1.5 hover:bg-gray-50 rounded-lg transition-colors"
          aria-label="Access"
        >
          <img
            src="assets/icons/key-brand.png"
            alt="Access"
            class="w-7 h-7 object-contain"
          />
        </button>
      </div>
    }

    <!-- TABLET & DESKTOP -->
    @if (!isMobile()) {

      <div
        class="flex items-center gap-2 md:gap-3 sm:px-6 px-3 h-full relative"
        [class.flex-1]="isTablet()"
        [class.flex-shrink-0]="!isTablet()"
        [class.sm:border-l-2]="!isTablet()"
        [class.border-[`#EBEFF2`]]="!isTablet()"
      >
        <!-- Tablet: Search ICON when inactive -->
        @if (isTablet()) {
        <div class="flex items-center gap-2 w-full flex-1">
          <p-iconfield iconPosition="left" class="w-full">
            <p-inputicon (click)="searchQuery ? clearSearch() : null" class="pointer-events-auto cursor-pointer">
              @if (searchQuery) {
                <img src="assets/icons/add.svg" class="rotate-45" alt="Clear" width="16" height="16" />
              } @else {
                <img src="assets/icons/search.svg" alt="Search" width="16" height="16" />
              }
            </p-inputicon>

            <input
              type="text"
              pInputText
              placeholder="Search for people, group, collabs, listing..."
              class="w-full !text-[16px] !text-semibold border-none !text-[#334D6E]"
              [value]="searchQuery"
              (input)="onSearchInput($event)"
              (focus)="onSearchFocus()"
            />
          </p-iconfield>
        </div>
      }


        <!-- Desktop: Always show search input -->
        @if (isDesktop()) {
          <p-iconfield iconPosition="left">
            <p-inputicon (click)="searchQuery ? clearSearch() : null" class="pointer-events-auto cursor-pointer">
              @if (searchQuery) {
                <img src="assets/icons/add.svg" class="rotate-45" alt="Clear" width="16" height="16" />
              } @else {
                <img src="assets/icons/search.svg" alt="Search" width="16" height="16" />
              }
            </p-inputicon>
            <input
              type="text"
              pInputText
              placeholder="Search"
              class="w-[80px] sm:w-[120px] md:w-[150px] !text-[16px] font-semibold border-none !text-[#334D6E]"
              [value]="searchQuery"
              (input)="onSearchInput($event)"
              (focus)="onSearchFocus()"
            />
          </p-iconfield>
        }

       

        <!-- Access button -->
        <a [routerLink]="['/home']"
          (click)="onLogoClick($event)"
          class="p-1.5 sm:p-2 hover:bg-gray-50 rounded-lg transition-colors flex-shrink-0"
          aria-label="Home"
        >
          <img
            src="assets/icons/key-brand.png"
            alt="Home"
            class="w-6 h-6 sm:w-8 sm:h-8 object-contain"
          />
        </a>

      </div>
    }

    <!-- Search results dropdown -->
    @if (showSearchDropdown) {
      <div class="absolute top-[60px] lg:top-[64px] left-1/2 -translate-x-1/2 lg:left-auto lg:right-[24px] lg:translate-x-0 search-dropdown-container w-[380px] sm:w-[635px] lg:w-[635px] max-w-[calc(100%-22px)] bg-white shadow-[0_4px_20px_rgba(0,0,0,0.12)] border border-[#F4F4F4] rounded-[5px] z-[300] overflow-hidden flex flex-col"
           style="max-height: 538px;">
        <div class="p-5 sm:p-6 flex-1 flex flex-col min-h-0 overflow-hidden relative">
          <!-- Close button -->
          <button (click)="closeSearch()" aria-label="Close search panel" class="absolute top-[18px] right-[26px] sm:top-[22px] sm:right-[26px] z-20 p-1 hover:bg-gray-50 rounded-full transition-colors flex items-center justify-center">
            <img src="assets/icons/dismiss.png" class="w-6 h-6 object-contain" />
          </button>

          <!-- Fixed Results Header (Only when searching) -->
          @if (searchQuery) {
            <div class="flex items-center justify-between mb-4 border-b border-gray-50 pb-4 pr-12">
              <div class="flex items-center gap-4">
                <h3 #resultsHeader class="text-[20px] font-bold text-[#192A3E]">Results</h3>
                <button (click)="seeAllResults()" class="text-[#238EC6] text-[18px] font-bold hover:underline">See all</button>
              </div>
            </div>
          }

          <!-- Main Content Scrollable Area -->
          <div #scrollContainer class="flex-1 overflow-y-auto overflow-x-hidden pr-2 custom-scrollbar">

            <!-- Initial state -->
            @if (!searchQuery) {
              <div class="pr-8">
                <h3 class="text-[20px] font-bold text-[#192A3E] leading-tight mb-4 text-left">Try searching for names of people, groups, or communities, or the title of an event, meetup, or fundraiser.</h3>
                <ul class="space-y-4">
                  <li class="flex items-center gap-3 text-[#334D6E] cursor-pointer hover:text-[#2E7FBE]">
                    <img src="assets/icons/search.svg" class="w-4 h-4" />
                    <span class="text-[16px] font-semibold truncate">Names of people, groups or communities</span>
                  </li>
                  <li class="flex items-center gap-3 text-[#334D6E] cursor-pointer hover:text-[#2E7FBE]">
                    <img src="assets/icons/search.svg" class="w-4 h-4" />
                    <span class="text-[16px] font-semibold truncate">Title of listings</span>
                  </li>
                  <li class="flex items-center gap-3 text-[#334D6E] cursor-pointer hover:text-[#2E7FBE]">
                    <img src="assets/icons/search.svg" class="w-4 h-4" />
                    <span class="text-[16px] font-semibold truncate">Title of meetups</span>
                  </li>
                  <li class="flex items-center gap-3 text-[#334D6E] cursor-pointer hover:text-[#2E7FBE]">
                    <img src="assets/icons/search.svg" class="w-4 h-4" />
                    <span class="text-[16px] font-semibold truncate">Title of fundraise</span>
                  </li>
                </ul>
              </div>
            }

            <!-- Results state -->
            @if (searchQuery) {
              <div>
                @if (isSearching && searchResults.length === 0) {
                  <div class="py-6 text-center text-[#7D838A]">
                     Searching...
                  </div>
                } @else {
                  <ul class="space-y-3">
                    @for (result of searchResults.slice(0, showAllResultsInDropdown() ? searchResults.length : 5); track result.id + result.source_type) {
                      <li class="group">
                        <button 
                          (click)="redirectToResult(result)"
                          class="flex items-center text-left w-full gap-4 border-b border-gray-50 last:border-0 hover:bg-gray-50 transition-colors py-2"
                        >
                          <img src="assets/icons/search.svg" class="w-5 h-5 flex-shrink-0 relative top-[-5px]" />
                          <div class="flex-1 min-w-0 leading-tight">
                            <span class="font-bold text-[#334D6E] group-hover:text-[#2E7FBE] text-[17px] line-clamp-1 truncate">{{ result.title }}</span>
                            <span class="text-[#7D838A] text-[15px] block line-clamp-1 truncate">{{ result.sub_title || result.title }}</span>
                          </div>
                          
                          <div class="flex-shrink-0 w-10 h-10 overflow-hidden border border-gray-100 shadow-sm flex items-center justify-center relative"
                               [class.avatar-initials]="!hasSearchImage(result) || imageErrors[result.id + result.source_type]"
                               [class.rounded-full]="result.source_type === 'user' || result.source_type === 'collab' || result.source_type === 'meetup_group' || result.source_type === 'meetup_user'"
                               [class.rounded-lg]="result.source_type !== 'user' && result.source_type !== 'collab' && result.source_type !== 'meetup_group' && result.source_type !== 'meetup_user'">

                            <span class="text-white text-[14px] font-bold z-0">{{ result.title | initials }}</span>

                            @if (hasSearchImage(result) && !imageErrors[result.id + result.source_type]) {
                              @if (isSearchImageFlagged(result)) {
                                <img [src]="getSearchImageUrl(result)"
                                     class="absolute inset-0 w-full h-full object-cover z-10 blur-sm opacity-60"
                                     (error)="onImageError(result)" />
                                <div class="absolute inset-0 flex flex-col items-center justify-center gap-0.5 z-20">
                                  <img src="assets/icons/eye-icon-white.png" class="h-[14px] w-[14px]">
                                  <span class="text-[7px] text-white font-medium text-center leading-tight drop-shadow">Explicit<br>content</span>
                                </div>
                              } @else {
                                <img [src]="getSearchImageUrl(result)"
                                     class="absolute inset-0 w-full h-full object-cover z-10"
                                     (error)="onImageError(result)" />
                              }
                            }
                          </div>
                        </button>
                      </li>
                    } @empty {
                      @if (!isSearching) {
                        <div class="py-6 text-center text-[#7D838A]">
                          No results found for "{{ searchQuery }}"
                        </div>
                      }
                    }

                    @if (!showAllResultsInDropdown() && searchResults.length > 5) {
                      <li class="pt-2 pb-4 text-center">
                        <button (click)="showAllResultsInDropdown.set(true)" class="text-[#2E7FBE] text-[15px] font-bold hover:underline">
                          See more
                        </button>
                      </li>
                    }

                    @if (showAllResultsInDropdown() && hasMoreResults) {
                      <li class="pt-2 pb-4 text-center">
                        <button #loadMoreTrigger (click)="loadMore()" [disabled]="isLoadingMore" class="text-[#2E7FBE] text-[15px] font-bold hover:underline">
                          @if (isLoadingMore) { Loading... } @else { Load more }
                        </button>
                      </li>
                    }
                  </ul>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }

  </div>

  @if (isImpersonating() && isDesktop()) {
    <button type="button" (click)="returnToSuperAdmin()"
      class="absolute left-1/2 -translate-x-1/2 -bottom-[9px] z-[201] bg-[#E28C0A] text-white text-[10px] font-semibold uppercase tracking-wide px-[8px] py-[2px] rounded-full shadow-sm whitespace-nowrap flex items-center gap-1 hover:opacity-90 transition-opacity">
      <i class="pi pi-arrow-left !text-[9px]"></i>
      Back to Super Admin Access
    </button>
  } @else if (isSuperAdmin && isDesktop()) {
    <span class="absolute left-1/2 -translate-x-1/2 -bottom-[9px] z-[201] bg-[#E28C0A] text-white text-[10px] font-semibold uppercase tracking-wide px-[5px]  rounded-full shadow-sm whitespace-nowrap pointer-events-none">
      Super Admin Access
    </span>
  }

  <!-- Backdrop for closing search dropdown -->
  @if (showSearchDropdown) {
    <div class="fixed inset-0 z-[150]" (click)="closeSearchDropdown()"></div>
  }
</header>


@if (showBottomNav() && !uiState.hideBottomNav() && !shouldHideNavbar()) {
  <nav class="fixed bottom-0 left-0 right-0 z-[1000] bg-white border-t border-[#C8D0D5] shadow-[0_-2px_10px_rgba(0,0,0,0.1)]">
    <div class="flex items-center overflow-x-auto justify-around px-2 pb-[20px]">
      @for (item of menuItems; track item.label) {
        <a
          #bottomNavItem
          [routerLink]="item.routerLink"
          (click)="onNavItemClick(item)"
          routerLinkActive
          [class.active-bottom-nav]="isItemActive(item, rla.isActive)"
          [routerLinkActiveOptions]="{ exact: item.label === 'Home' }"
          #rla="routerLinkActive"
          class="flex flex-col items-center justify-center flex-shrink-0 px-[10px] pb-2 pt-[11px] text-[#7D838A] hover:text-[#334D6E] transition-colors"
        >
          <div class="relative w-[46px] h-[26px] flex-shrink-0">
            <img [src]="item.icon" alt="" aria-hidden="true"
              class="absolute inset-0 w-full h-full object-contain"
              [class.opacity-0]="isItemActive(item, rla.isActive)" />
            <img [src]="item.activeIcon"  alt="" aria-hidden="true"
              class="absolute inset-0 w-full h-full object-contain"
              [class.opacity-0]="!isItemActive(item, rla.isActive)" />
            @if (hasUnreadFor(item.label)) {
              <span class="absolute top-0 right-[8px] w-2.5 h-2.5 rounded-full bg-[#C62828] border border-white" aria-hidden="true"></span><span class="sr-only">Unread messages</span>
            }
          </div>
          <span class="text-xs leading-3 mt-1 font-medium whitespace-nowrap"
                [class.text-[#334D6E]]="isItemActive(item, rla.isActive)">
            {{ item.label }}
          </span>
        </a>
      }
    </div>
  </nav>
}
@if (isAddReqPopupVisible) {
  <pa-add-request-popup (closeAddReqPopup)="isAddReqPopupVisible = false" />
}

<!-- ===== MOBILE / TABLET PROFILE PANEL (344px – 1023px) ===== -->
@if (showMobileProfilePanel()) {
  <!-- Backdrop -->
  <div class="fixed inset-0 z-[199] bg-black/30 lg:hidden" (click)="closeMobileProfilePanel()"></div>

  <!-- Panel -->
<div class="fixed top-[54px] left-[11px] pb-[15px] rounded-[10px] max-w-[387px] max-[689px]:max-w-[90%] z-[200] w-full bg-white overflow-hidden shadow-[4px_0_20px_rgba(0,0,0,0.12)] lg:hidden"
     [style.height]="mobileProfilePanelHeight()">
  <pa-profile
    [showTabs]="true"
    [isMyCollab]="true"
    [showSwitchAccount]="true"
    [showBorder]="false"
    [showProfileInfo]="true"
    (closePanel)="closeMobileProfilePanel()"
    (collabRailOffsetOut)="onCollabRailOffset($event)"
    (getVerifiedRequest)="onGetVerifiedRequest($event)"
  />
</div>
}

<pa-get-verified-popup
  [visible]="showVerificationPopup()"
  [targetUserData]="verificationTargetUser()"
  (closed)="showVerificationPopup.set(false); verificationTargetUser.set(null)"
/>
